<template>
  <div class="license-local">
    <el-form :model="form" label-width="108px" class="gen-form" :rules="rules" ref="form">
      <p class="intro">{{ $tt("生成设备本地 license.lic 并下载。IP / MAC / SN 至少填一种。") }}</p>
      <el-form-item :label="$tt('密钥描述')" prop="description">
        <el-input v-model="form.description" maxlength="80" :placeholder="$tt('请输入密钥描述')" />
      </el-form-item>
      <el-form-item :label="$tt('密钥级别')" prop="level">
        <el-radio-group v-model="form.level">
          <el-radio label="primary">{{ $tt("签名版（测试版）") }}</el-radio>
          <el-radio label="intermediate">{{ $tt("尊贵版") }}</el-radio>
          <el-radio label="senior">{{ $tt("旗舰版") }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item :label="$tt('生效时间')" prop="issued_time">
        <el-date-picker
          v-model="form.issued_time"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          :placeholder="$tt('证书生效时间')"
        />
      </el-form-item>
      <el-form-item :label="$tt('失效时间')" prop="expiry_time">
        <el-date-picker
          v-model="form.expiry_time"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          :placeholder="$tt('证书失效时间')"
        />
      </el-form-item>
      <el-form-item :label="$tt('IP地址')">
        <el-input
          type="textarea"
          v-model="form.ip_addr"
          :rows="2"
          :placeholder="$tt('逗号分隔，例如 127.0.0.1,10.0.0.2')"
        />
      </el-form-item>
      <el-form-item :label="$tt('SN号码')">
        <el-input
          type="textarea"
          v-model="form.sn"
          :rows="2"
          :placeholder="$tt('逗号分隔，例如 sn1001,sn1002')"
        />
      </el-form-item>
      <el-form-item :label="$tt('MAC地址')">
        <el-input
          type="textarea"
          v-model="form.mac"
          :rows="2"
          :placeholder="$tt('逗号分隔')"
        />
      </el-form-item>
      <el-form-item :label="$tt('CPU序列号')">
        <el-input v-model="form.cpu_serial" :placeholder="$tt('选填')" />
      </el-form-item>
      <el-form-item :label="$tt('主板序列号')">
        <el-input v-model="form.main_board_serial" :placeholder="$tt('选填')" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="genLoading" @click="submit">{{ $tt("生成并下载 LICENSE") }}</el-button>
      </el-form-item>
    </el-form>

    <div v-if="isSuper" class="history">
      <div class="history-head">{{ $tt("生成历史（仅超级管理员可见）") }}</div>
      <el-form :inline="true" size="small" class="hist-search">
        <el-form-item :label="$tt('操作人')">
          <el-input v-model="histQuery.generate_user_name" clearable :placeholder="$tt('姓名')" />
        </el-form-item>
        <el-form-item :label="$tt('描述')">
          <el-input v-model="histQuery.description" clearable :placeholder="$tt('密钥描述')" />
        </el-form-item>
        <el-form-item :label="$tt('级别')">
          <el-select v-model="histQuery.level" clearable :placeholder="$tt('全部')">
            <el-option :label="$tt('签名版')" value="primary" />
            <el-option :label="$tt('尊贵版')" value="intermediate" />
            <el-option :label="$tt('旗舰版')" value="senior" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="loadHistory(1)">{{ $tt("查询") }}</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="hist.result" border :empty-text="$tt('暂无记录')">
        <el-table-column :label="$tt('记录')" min-width="280">
          <template slot-scope="scope">{{ historyText(scope.row) }}</template>
        </el-table-column>
        <el-table-column prop="generate_user_name" :label="$tt('操作人')" width="120" />
        <el-table-column prop="create_time" :label="$tt('生成时间')" width="170" />
        <el-table-column :label="$tt('级别')" width="100">
          <template slot-scope="scope">{{ $tt(levelName(scope.row.level)) }}</template>
        </el-table-column>
        <el-table-column prop="description" :label="$tt('描述')" min-width="140" show-overflow-tooltip />
        <el-table-column prop="issued_time" :label="$tt('生效')" width="170" />
        <el-table-column prop="expiry_time" :label="$tt('失效')" width="170" />
      </el-table>
      <Pagination
        v-if="hist.total > 8"
        :handleSizeChange="histSizeChange"
        :handleCurrentPageChange="histPageChange"
        :total="hist.total"
      />
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import { mapState } from "vuex";
import { isSuperAdmin } from "@/utils/account";

export default {
  components: { Pagination },
  computed: {
    ...mapState(["loginAccountInfo"]),
    isSuper() {
      return isSuperAdmin(this.loginAccountInfo);
    },
  },
  data() {
    return {
      genLoading: false,
      form: {
        description: "",
        level: "primary",
        issued_time: "",
        expiry_time: "",
        ip_addr: "",
        sn: "",
        mac: "",
        cpu_serial: "",
        main_board_serial: "",
      },
      rules: {
        description: [{ required: true, message: "请输入密钥描述", trigger: "blur" }],
        level: [{ required: true, message: "请选择级别", trigger: "change" }],
        issued_time: [{ required: true, message: "请选择生效时间", trigger: "change" }],
        expiry_time: [{ required: true, message: "请选择失效时间", trigger: "change" }],
      },
      histQuery: { generate_user_name: "", description: "", level: "" },
      hist: { result: [], total: 0 },
      histPage: 1,
      histSize: 8,
    };
  },
  mounted() {
    if (this.isSuper) {
      this.loadHistory(1);
    }
  },
  methods: {
    levelName(level) {
      if (level === "senior") return "旗舰版";
      if (level === "intermediate") return "尊贵版";
      if (level === "primary") return "签名版";
      return level || "-";
    },
    historyText(row) {
      const who = row.generate_user_name || this.$tt("未知用户");
      const when = row.create_time || "";
      const lv = this.$tt(this.levelName(row.level));
      const what = row.description ? lv + "「" + row.description + "」" : lv;
      return (
        who +
        " " +
        this.$tt("于") +
        " " +
        when +
        " " +
        this.$tt("生成了") +
        " " +
        what +
        this.$tt("密钥")
      );
    },
    submit() {
      this.$refs.form.validate((ok) => {
        if (!ok) return;
        if (this.form.issued_time >= this.form.expiry_time) {
          this.$message.error("证书失效时间需要大于证书生效时间");
          return;
        }
        if (!this.form.ip_addr && !this.form.mac && !this.form.sn) {
          this.$message.error("IP、MAC、SN 至少填写一种");
          return;
        }
        this.genLoading = true;
        this.$request
          .generateLocalLicense(this.form)
          .then((res) => {
            this.genLoading = false;
            if (res && res.status === "fail") {
              this.$message.error(res.msg || "生成失败");
              return;
            }
            this.$message.success("已开始下载");
            if (this.isSuper) {
              this.loadHistory(this.histPage);
            }
          })
          .catch(() => {
            this.genLoading = false;
            this.$message.error("下载失败");
          });
      });
    },
    loadHistory(page) {
      this.histPage = page || 1;
      this.$request
        .queryLicenseGenerateHistory({
          page_num: this.histPage,
          page_size: this.histSize,
          generate_user_name: this.histQuery.generate_user_name,
          description: this.histQuery.description,
          level: this.histQuery.level,
        })
        .then((res) => {
          if (res.status != "success") {
            this.$message.error(res.msg);
            return;
          }
          this.hist = res.data || { result: [], total: 0 };
        });
    },
    histSizeChange(v) {
      this.histSize = v;
      this.loadHistory(1);
    },
    histPageChange(v) {
      this.loadHistory(v);
    },
  },
};
</script>

<style scoped lang="scss">
.license-local {
  padding: 16px 20px 32px;
  text-align: left;
}
.intro {
  margin: 0 0 16px;
  color: #909399;
  font-size: 13px;
}
.gen-form {
  max-width: 720px;
  background: #fff;
  padding: 20px 24px 8px;
  margin-bottom: 24px;
}
.history {
  background: #fff;
  padding: 16px 20px 24px;
}
.history-head {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 12px;
}
.hist-search {
  margin-bottom: 8px;
}
</style>
